import { Form, Row, Col, Container } from 'react-bootstrap';
import { Address } from '../FormFields/Address';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { burnSiteSchema } from '../../schemas/burnSiteSchema';
import { ControlButtons } from '../ControlButtons';
import { ParcelNumberRepeater } from './ParcelNumberRepeater';

// TODO: This component was very coupled to the form stepper, and unfortunately still is
// semi-coupled to the form stepper in many ways, even though it needs to be re-used.
// The method currently in place to allow reuse with the formComponent prop is not ideal
// and was implemented just to get reuse somewhat working. The form stepper handling
// really should be pulled out into its own HOC or something so this can be reconfigured
// as more of a strictly reusable form component.

export const BurnSite = ({
	currBurnSite = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	formComponent = false,
	prefix,
	register: registerAsComponent,
	control: parentFormControl,
	formState: parentFormState,
	autoFocus,
}) => {
	let formState, register, control;

	const {
		register: standaloneRegister,
		handleSubmit,
		formState: standaloneFormState,
		control: standaloneFormControl,
	} = useForm({
		resolver: yupResolver(burnSiteSchema),
		defaultValues: currBurnSite,
	});

	if (formComponent) {
		formState = parentFormState;
		register = registerAsComponent;
		control = parentFormControl;
	} else {
		formState = standaloneFormState;
		register = standaloneRegister;
		control = standaloneFormControl;
	}

	return (
		<>
			<Container className="component mt-5">
				<h2 className="mb-4">
					{!formComponent ? 'Where is the burn site?' : 'Burn Site'}
				</h2>
				<Address
					autoFocus={!formComponent || autoFocus}
					register={register}
					prefix={prefix}
					error={formState.errors}></Address>

				<Row>
					<Col>
						<Form.Group>
							<Form.Label>Site size in Acres</Form.Label>
							<Form.Control
								type="number"
								{...register('acres', {
									setValueAs: val => (!val ? null : parseInt(val)),
								})}
							/>
							<Form.Text className="text-danger">
								{formState.errors.acres?.message}
							</Form.Text>
						</Form.Group>
					</Col>{' '}
				</Row>

				<Row className="mb-4">
					<Col>
						<Form.Label>Parcel Number(s)</Form.Label>
						<ParcelNumberRepeater
							register={register}
							control={control}
							error={formState.errors}
						/>
					</Col>
				</Row>
			</Container>
			{!formComponent && (
				<Container>
					<ControlButtons
						onNext={handleSubmit(onNext)}
						onPrev={onPrevious}
						onSubmit={onSubmit}
						disablePrev={disablePrev}
						disableNext={disableNext}
						finalStep={finalStep}
					/>
				</Container>
			)}
		</>
	);
};
